export default __webpack_public_path__ + "static/media/carms.e6d39e68.jpeg";